import { createSelector } from '../../shared';
import type { AppState, NavigationState } from '..';

export const isInDeepLinkMode = createSelector<AppState, NavigationState, boolean>(
    'isInDeepLinkMode',
    [(appState: AppState) => appState.view.navigationState],
    navigationState => {
        return (
            Boolean(navigationState.deepLinkedGroupSmtp) ||
            (navigationState.clickedHubPersona &&
                navigationState.clickedHubPersona.origin === 'DeepLink')
        );
    }
);
